import * as types from './constants';

// Daily `by_user` analytics histogram (key = day, clicks, active_links, gmv) for one creator
// over the last 12 months; summed per month by the Creator page.
const initialState = {
  histogram: [],
  loaded: false,
  loading: false,
  errors_api: {},
  errorStatus: null
};

const actions = {
  // Get Creator Monthly Sales
  [types.GET_CREATOR_MONTHLY_SALES_REQUEST]: state => ({
    ...state,
    loading: true,
    errors_api: {},
    errorStatus: null
  }),

  [types.GET_CREATOR_MONTHLY_SALES_DONE]: (state, { payload }) => ({
    ...state,
    histogram: payload,
    loaded: true,
    loading: false
  }),

  [types.GET_CREATOR_MONTHLY_SALES_FAILED]: (state, { payload }) => ({
    ...state,
    histogram: [],
    loaded: true,
    loading: false,
    errors_api: payload?.errors_api || {},
    errorStatus: payload?.status || null
  }),

  [types.GET_CREATOR_MONTHLY_SALES_RESET]: () => ({ ...initialState })
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};
